import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";

export default function TermsPage() {
  return (
    <div className="pt-24 pb-16">
      <section className="py-16">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto"
          >
            <Badge variant="info" className="mb-4">
              Legal
            </Badge>
            <h1 className="font-display text-4xl md:text-5xl font-bold mb-4">
              Terms of Service
            </h1>
            <p className="text-muted-foreground mb-12">
              Last updated: January 25, 2026
            </p>

            <div className="prose prose-invert prose-lg max-w-none">
              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                1. Acceptance of Terms
              </h2>
              <p className="text-muted-foreground mb-6">
                By accessing or using the services provided by Echopeak Labs
                ("Company," "we," "our," or "us"), you agree to be bound by
                these Terms of Service. If you do not agree to these terms,
                please do not use our services.
              </p>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                2. Services Description
              </h2>
              <p className="text-muted-foreground mb-6">
                Echopeak Labs provides software development consulting and
                related professional services. All development work is performed
                directly in client-owned repositories and infrastructure. The
                specific scope of services will be defined in individual project
                agreements or statements of work.
              </p>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                3. Client Infrastructure Requirements
              </h2>
              <p className="text-muted-foreground mb-4">
                To engage with Echopeak Labs, clients must provide:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
                <li>
                  Access to client-owned code repository (GitHub, GitLab,
                  Bitbucket, etc.)
                </li>
                <li>
                  Access to client-owned cloud infrastructure account (AWS,
                  Azure, GCP, etc.)
                </li>
                <li>
                  Appropriate permissions for our team to perform development
                  work
                </li>
                <li>
                  Client is responsible for all infrastructure costs and
                  operational expenses
                </li>
              </ul>
              <p className="text-muted-foreground mb-6">
                Echopeak Labs does not host, own, or maintain any client
                services, applications, or data. All work is performed directly
                in client-owned environments.
              </p>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                4. Client Obligations
              </h2>
              <p className="text-muted-foreground mb-4">
                As a client, you agree to:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
                <li>
                  Provide and maintain necessary repository and infrastructure
                  access
                </li>
                <li>Provide accurate and complete information as required</li>
                <li>
                  Respond to requests for feedback and approvals in a timely
                  manner
                </li>
                <li>Pay all fees according to the agreed payment terms</li>
                <li>Manage and pay for all infrastructure and hosting costs</li>
                <li>Not use our services for any unlawful purpose</li>
                <li>
                  Maintain the confidentiality of any proprietary information
                  shared
                </li>
              </ul>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                5. Intellectual Property and Ownership
              </h2>
              <p className="text-muted-foreground mb-6">
                You own 100% of all work, code, and assets produced by Echopeak
                Labs. All work created during an engagement is considered "work
                for hire," with all intellectual property rights belonging to
                you from the moment of creation. We retain ownership only of
                pre-existing materials, frameworks, and tools used in delivering
                services, which are licensed to you as needed for your project.
              </p>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                6. Payment Terms
              </h2>
              <p className="text-muted-foreground mb-6">
                Payment terms will be specified in individual project
                agreements. Clients may choose hourly, fixed price, or
                milestone-based payment structures. Unless otherwise agreed,
                invoices are due within 30 days of receipt. Late payments may
                incur interest charges and may result in suspension of services.
                All infrastructure and hosting costs are the responsibility of
                the client.
              </p>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                7. Confidentiality
              </h2>
              <p className="text-muted-foreground mb-6">
                Both parties agree to maintain the confidentiality of
                proprietary information shared during the engagement. This
                obligation survives the termination of any agreement between us.
              </p>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                8. Limitation of Liability
              </h2>
              <p className="text-muted-foreground mb-6">
                To the maximum extent permitted by law, Echopeak Labs shall not
                be liable for any indirect, incidental, special, consequential,
                or punitive damages, or any loss of profits or revenues, whether
                incurred directly or indirectly. Client is solely responsible
                for the operation, maintenance, and hosting of their
                applications and infrastructure.
              </p>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                9. Termination
              </h2>
              <p className="text-muted-foreground mb-6">
                Either party may terminate an engagement with 30 days written
                notice. Upon termination, client shall pay for all services
                rendered through the termination date. All work completed
                remains the property of the client and resides in their
                repositories and infrastructure.
              </p>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                10. Governing Law
              </h2>
              <p className="text-muted-foreground mb-6">
                These Terms shall be governed by and construed in accordance
                with the laws of Ontario, Canada, without regard to its conflict
                of law provisions.
              </p>

              <h2 className="font-display text-2xl font-bold mt-8 mb-4">
                11. Contact
              </h2>
              <p className="text-muted-foreground">
                For questions about these Terms, please contact us at:
                <br />
                Email: contact@echopeaklabs.com
                <br />
                Location: Ontario, Canada
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
